import { render, staticRenderFns } from "./TournamentDetailDialog.vue?vue&type=template&id=54f55ae5&scoped=true"
import script from "./TournamentDetailDialog.vue?vue&type=script&lang=js"
export * from "./TournamentDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./TournamentDetailDialog.vue?vue&type=style&index=0&id=54f55ae5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f55ae5",
  null
  
)

export default component.exports